/**
 * Search parameter names used in Firewatch filter context
 * These constants ensure consistency across all filter operations
 */
export const FIREWATCH_SEARCH_PARAMS = {
  TYPE: "type",
  RISK_RATING: "riskRating",
  RISK_FACTOR_MRN: "riskFactorMrn",
  POLICY_MRN: "policyMrn",
  STATE: "state",
  PLATFORM: "platform",
  QUERY_TERM: "queryTerm",
} as const;

/**
 * Array of all search parameter names for bulk operations
 */
export const ALL_FIREWATCH_SEARCH_PARAMS = Object.values(
  FIREWATCH_SEARCH_PARAMS,
);
